import { render, staticRenderFns } from "./AdminReportsCustomerMonthly.vue?vue&type=template&id=0ebc1a2a&scoped=true&"
import script from "./AdminReportsCustomerMonthly.vue?vue&type=script&lang=js&"
export * from "./AdminReportsCustomerMonthly.vue?vue&type=script&lang=js&"
import style0 from "./AdminReportsCustomerMonthly.vue?vue&type=style&index=0&id=0ebc1a2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebc1a2a",
  null
  
)

export default component.exports